import React from 'react';
import { useSnackbar, SnackbarContent } from 'notistack';
import ThemeSnackbarContent from 'components/Snackbar/SnackbarContent';

// @material-ui/icons
import AddAlert from '@material-ui/icons/AddAlert';

const SnackMessage = React.forwardRef((props, ref) => {
	const { closeSnackbar } = useSnackbar();
	const { message, color } = props;

	const handleClose = () => {
		closeSnackbar(props.id);
	};

	return (
		<SnackbarContent ref={ref} >
			<ThemeSnackbarContent
				message={message}
				color={color}
				icon={AddAlert}
				closeNotification={handleClose}
				close
			/>
		</SnackbarContent>
	);
});

export default SnackMessage;
